import React from 'react'

interface StarCloudIconProps {
  size?: number
  selected?: boolean
}

const CreativeOSAISearchIcon: React.FC<StarCloudIconProps> = ({ size = 27 }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 42 41"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      preserveAspectRatio="xMidYMid meet"
    >
      <path
        d="M6.87939 34.411L24.8771 16.4133"
        stroke="#673BEC"
        strokeWidth="2.7"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.0513 10.768L10.9228 10.0593L10.2118 7.92851C9.98234 7.24001 8.84159 7.24001 8.61209 7.92851L7.90109 10.0593L5.77259 10.768C5.42834 10.8828 5.19434 11.2045 5.19434 11.569C5.19434 11.9335 5.42834 12.2553 5.77259 12.37L7.90109 13.0788L8.61209 15.2095C8.72684 15.5538 9.04859 15.7855 9.41084 15.7855C9.77309 15.7855 10.0971 15.5515 10.2096 15.2095L10.9206 13.0788L13.0491 12.37C13.3933 12.2553 13.6273 11.9335 13.6273 11.569C13.6273 11.2045 13.3956 10.8828 13.0513 10.768Z"
        fill="#673BEC"
      />
      <path
        d="M38.1722 29.326L35.3305 28.3788L34.3832 25.537C34.075 24.619 32.5562 24.619 32.248 25.537L31.3007 28.3788L28.459 29.326C28 29.479 27.6895 29.9088 27.6895 30.3925C27.6895 30.8763 28 31.306 28.459 31.459L31.3007 32.4063L32.248 35.248C32.401 35.707 32.833 36.0175 33.3167 36.0175C33.8005 36.0175 34.2302 35.707 34.3855 35.248L35.3327 32.4063L38.1745 31.459C38.6335 31.306 38.944 30.8763 38.944 30.3925C38.944 29.9088 38.6312 29.479 38.1722 29.326Z"
        fill="#673BEC"
      />
      <path
        d="M15.8794 5.72354C16.8114 5.72354 17.5669 4.96802 17.5669 4.03604C17.5669 3.10406 16.8114 2.34854 15.8794 2.34854C14.9474 2.34854 14.1919 3.10406 14.1919 4.03604C14.1919 4.96802 14.9474 5.72354 15.8794 5.72354Z"
        fill="#673BEC"
      />
      <path
        d="M23.1876 4.71555L28.4503 8.1513L34.2643 5.7663L32.6218 11.8323L36.6876 16.6225L30.4123 16.9353L27.1116 22.2835L24.8751 16.411L18.7686 14.926L23.6623 10.9818L23.1876 4.71555Z"
        stroke="#673BEC"
        strokeWidth="2.7"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export default CreativeOSAISearchIcon
